import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.645 3.879a.7.7 0 0 1 .7-.7h5.31a.7.7 0 0 1 .7.7v3.318a.7.7 0 0 1-.7.7h-5.31a.7.7 0 0 1-.7-.7V3.88Zm1.4.7v1.918h3.91V4.58h-3.91ZM2 12.803a.7.7 0 0 1 .7-.7h5.31a.7.7 0 0 1 .7.7v3.318a.7.7 0 0 1-.7.7H2.7a.7.7 0 0 1-.7-.7v-3.318Zm1.4.7v1.918h3.91v-1.918H3.4Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.3 9.324H5.355a.7.7 0 0 0-.7.7v2.323h1.4v-1.623h7.89v1.623h1.4v-2.323a.7.7 0 0 0-.7-.7H10.7V7.7H9.3v1.623Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.29 12.65a.7.7 0 0 1 .7-.7h5.31a.7.7 0 0 1 .7.7v3.319a.7.7 0 0 1-.7.7h-5.31a.7.7 0 0 1-.7-.7v-3.318Zm1.4.7v1.919h3.91v-1.918h-3.91Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=HierarchyIcon20.js.map